
import {ChangeDetectionStrategy, Component, OnInit, inject, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MaterialModule} from '../../../material.module';

type AuthCallbackMessage = {
    type: 'auth:callback';
    ok: boolean;
    payload?: { code?: string | null; state?: string | null };
    error?: string;
    state?: string;
};

@Component({
    selector: 'app-connect-auth-callback',
    standalone: true,
    imports: [MaterialModule],
    templateUrl: './connect-auth-callback.component.html',
    styleUrls: ['./connect-auth-callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectAuthCallbackComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    readonly posted = signal<boolean>(false);

    ngOnInit(): void {
        this.postToOpener();
    }

    private postToOpener(): void {
        try {
            const params = this.route.snapshot.queryParamMap;
            const code = params.get('code');
            const state = params.get('state');
            const error = params.get('error');
            const ok = !error;

            const message: AuthCallbackMessage = {
                type: 'auth:callback',
                ok,
                payload: ok ? {code, state} : undefined,
                error: error || undefined,
                state: state || undefined,
            };

            const targetOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : '*';
            const opener = (typeof window !== 'undefined' ? (window as any).opener : null) as any;
            if (opener && typeof opener.postMessage === 'function') {
                try {
                    opener.postMessage(message, targetOrigin);
                    this.posted.set(true);
                } catch {
                    // ignore
                }
            }

            setTimeout(() => {
                try {
                    window.close();
                } catch {
                    // ignore
                }
            }, 200);
        } catch {
            // ignore
        }
    }
}

